import { useFormik } from 'formik';
import { cleanObj } from '../../../../../shared/utils/objects';
import { OrbitHistoryFilter } from '../types';

const initialValues: OrbitHistoryFilter = {
    document: '',
};

export const useOrbitHistoryFilters = (
    onFilter?: (data: OrbitHistoryFilter) => void
) => {
    const formik = useFormik({
        initialValues,
        onSubmit: (data) => {
            if (onFilter) onFilter(cleanObj(data) || {});
        },
    });

    return { formik };
};
